export const organisation = {
  title: "Organisation",
  subtitle: "Hantera organisationer och deras detaljer",
  health_title: "Kundkonto",
  health_subtitle: "Hantera konton och deras detaljer",
  sub_organisations_title: "Underorganisationer för",
  sub_organisations_subtitle:
    "Lägg till en underorganisation och definiera dess grundläggande uppgifter. Behörigheter och användare kan hanteras senare.",
  health_sub_organisations_title: "Boenden för",
  health_sub_organisations_subtitle:
    "Lägg till ett boende och definiera dess grundläggande uppgifter. Behörigheter och användare kan hanteras senare.",
  add_sub_organisation_title: "Lägg till ny underorganisation",
  add_sub_organisation_subtitle:
    "Skapa en ny underorganisation och lägg till dess grundläggande uppgifter. Behörigheter och användare kan hanteras när som helst.",
  health_add_sub_organisation_title: "Lägg till nytt boende",
  health_add_sub_organisation_subtitle:
    "Skapa ett nytt boende och lägg till dess grundläggande uppgifter. Behörigheter och användare kan hanteras när som helst.",
  no_sub_organisations_title: "Inga underorganisationer än",
  no_sub_organisations_subtitle:
    "Skapa en underorganisation för att hantera användare och aktiviteter.",
  health_no_sub_organisations_title: "Inga boenden ännu",
  health_no_sub_organisations_subtitle:
    "Skapa ett boende för att hantera användare och aktiviteter.",
  create_new: "Skapa ny +",
  organisation_name: "Organisationsnamn",
  organisation_number: "Organisationsnummer",
  health_organisation_name: "Kontonamn",
  health_organisation_number: "Kontonummer",
  health_sub_organisation_name: "Boendenamn",
  location: "Plats",
  action: "Åtgärd",
  no_sub_organisation_option: "Ingen underorganisation",

  // Add Organisation Screen
  add_title: "Lägg till ny organisation",
  health_add_title: "Lägg till nytt kundkonto",
  add_subtitle:
    "Skapa en ny organisation och lägg till dess grundläggande detaljer. Du kan tilldela behörigheter och användare när som helst.",
  health_add_subtitle:
    "Skapa ett nytt kundkonto och lägg till dess grundläggande detaljer. Du kan tilldela behörigheter och användare när som helst.",
  basic_information: "Grundläggande information",
  organisation_name_label: "Organisationsnamn",
  sub_organisation_name_label: "Underorganisationsnamn",
  health_organisation_name_label: "Kundkonto",
  health_sub_organisation_name_label: "Boenden",
  organisation_number_label: "Organisationsnummer",
  address: "Adress",
  second_address: "Andra adressen",
  postal_code: "Postnummer",
  location_label: "Plats",
  have_sub_organisation: "Ha underorganisation",
  sub_org_info:
    "Om aktiverad kommer underorganisationer att användas. Annars kommer avdelningar att användas.",
  process_owner_title: "Processägare - Behörighet 1 (Företagskontots ägare)",
  process_owner_title_2:
    "Processägare - Behörighet 2 (Underorganisations- eller avdelningskontoägare)",
  health_process_owner_title_2:
    "Processägare - Behörighet 2 (Boendekontoägare)",
  process_owner_title_3:
    "Processägare - Behörighet 3 (Admin för avdelning eller underorganisation)",
  health_process_owner_title_3:
    "Processägare - Behörighet 3 (Admin för boende)",
  person_email: "Personens e-post",
  add_button: "Lägg till",
  selected_persons: "Valda personer",
  add_new_organisation: "Lägg till ny organisation",
  add_and_close: "Lägg till och stäng",
  cancel: "Avbryt",

  // Placeholders
  placeholder_organisation_name: "Ange organisationsnamn",
  health_placeholder_organisation_name: "Ange kontonamn",
  placeholder_sub_organisation_name: "Ange underorganisationsnamn",
  health_placeholder_sub_organisation_name: "Ange boendenamn",
  placeholder_organisation_number: "Ange organisationsnummer",
  health_placeholder_organisation_number: "Ange kontonummer",
  placeholder_address: "Skriv din adress här",
  placeholder_second_address: "Skriv din andra adress här",
  placeholder_postal_code: "Ange postnummer",
  placeholder_location: "Ange plats",
  placeholder_person_email: "Ange e-postadress här...",

  // Error messages
  error_email_required: "E-post är obligatorisk",
  error_email_invalid: "Ange en giltig e-postadress",
  error_email_already_added: "Denna e-post har redan lagts till",

  // Edit Organisation Screen
  edit_title: "Redigera organisation",
  health_edit_title: "Redigera konto",
  health_edit_sub_title: "Redigera boende",
  edit_subtitle: "Uppdatera grundläggande information och behörigheter",
  save_changes: "Spara ändringar",
  delete_button: "Radera",

  // Notifications
  delete_success: "Organisation raderad",
  delete_error: "Det gick inte att radera organisationen",
  create_success: "Organisation skapad",
  create_success_but_admins_failed:
    "Organisation skapad, men tilldelning av vissa administratörer misslyckades.",
  error_conflict_connected:
    "Det här kontot är kopplat till en annan organisation.",
  create_error: "Det gick inte att skapa organisationen",
  update_success: "Organisation uppdaterad",
  update_error: "Det gick inte att uppdatera organisationen",
  load_error: "Det gick inte att ladda organisationsdata",

  // Confirmation Dialog
  confirm_delete_title: "Radera organisation",
  confirm_delete_message:
    "Är du säker på att du vill radera denna organisation?",
  confirm_delete_yes: "Ja, radera",

  // Sub-organisation delete
  confirm_delete_sub_org_title: "Radera underorganisation",
  confirm_delete_sub_org_message:
    "Är du säker på att du vill radera denna underorganisation?",
  delete_sub_org_success: "Underorganisation raderad",
  delete_sub_org_error: "Det gick inte att radera underorganisationen",

  //Add sub organisation
  show_qr_code: "Visa QR-kod",
  assign_responsible_users:
    "Tilldela ansvariga användare för denna underorganisation.",

  // Anpassade notifieringar för underorganisation/boende
  accommodation_create_success: "Boende skapat",
  accommodation_update_success: "Boende uppdaterat",
  accommodation_create_error: "Det gick inte att skapa boende",
  accommodation_update_error: "Det gick inte att uppdatera boende",
  suborg_create_success: "Underorganisation skapad",
  suborg_update_success: "Underorganisation uppdaterad",
  suborg_create_error: "Det gick inte att skapa underorganisation",
  suborg_update_error: "Det gick inte att uppdatera underorganisation",
};
